import { useScript } from './ScriptContext';
import StatementList from './StatementList';

const EVENT_LABELS = ['On Start', 'On Change', 'On Save'];

export default function EventCanvas({ eventIndex }) {
  const { drillStack } = useScript();

  const containerStyle = {
    flex: 1,
    overflowY: 'auto',
    padding: '8px 4px',
  };

  if (drillStack && drillStack.length > 0) {
    const { containerPath, breadcrumb } = drillStack[drillStack.length - 1];
    return (
      <div key={containerPath.join('-')} style={containerStyle}>
        <StatementList
          containerPath={containerPath}
          emptyLabel="drag statement blocks here"
          depth={0}
          breadcrumb={breadcrumb}
        />
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <StatementList
        containerPath={[eventIndex]}
        emptyLabel="drag statement blocks here"
        depth={0}
        breadcrumb={[EVENT_LABELS[eventIndex]]}
      />
    </div>
  );
}
